import privacyData from '../../components/TermsOfService/privacyData';
import LegalDocument from './LegalDocument';

const PrivacyPage = () => (
  <LegalDocument
    data={privacyData}
    relatedLinks={[
      { to: '/terms', label: 'Full Terms of Service' },
      { to: '/terms-summary', label: 'Terms summary' },
    ]}
  />
);

export default PrivacyPage;
